import { takeLatest, put, call, select, take } from 'redux-saga/effects';

import { selectConsentFormData, selectProgressCareUser } from '../selectors';
import * as acceptConsent from '../requests/accept-consent-req';
import * as inspectReq from '../requests/inspection-req';
import { APPOINTMENT_PROGRESS_TYPES } from '../progress-types';
import { APPOINTMENT_INSPECTION } from '../../../constants';
import { verifyInspection } from './inspectAll-saga';

const { CONSENT } = APPOINTMENT_INSPECTION;

function* validateConsentInspection() {
  const { id: concentId, version } = yield select(selectConsentFormData);
  const { id: userId } = yield select(selectProgressCareUser);
  const payload = {
    concentId,
    userConsentInfo: {
      accepted: true,
      userId,
      version,
    },
  };
  yield put(acceptConsent.actions.send(payload));
  yield take(acceptConsent.consts.SUCCEED);
  const inspection = {
    inspectionFor: CONSENT,
    completed: true,
    fieldList: [],
  };

  yield put(inspectReq.actions.setEntity({ [CONSENT]: inspection }));
  yield call(verifyInspection);
}

export default function* inspectConsentSaga() {
  yield takeLatest(
    APPOINTMENT_PROGRESS_TYPES.INSPECT_CONSENT,
    validateConsentInspection,
  );
}



// WEBPACK FOOTER //
// ./src/redux/appointmentForm/sagas/inspect-consent-saga.js